<div class="mep-dialog-header-icon">
	<mat-icon> add</mat-icon>
</div>
<div class="mep-dialog-title">
	{{ _lang("choose-project") }}
</div>
<div class="mep-dialog-content" mat-dialog-content>
	<mat-form-field class="w-100">
		<input
			#input
			#projectInput
			[formControl]="addForm"
			[matAutocomplete]="projectAuto.matAutocomplete"
			[placeholder]="_lang('please')"
			matInput
			class="autocomplete-right"
			appAutocompleteRight
		/>
		<app-project-autocomplete
			#projectAuto
			(elementSelected)="onProjectSelectionChanged($event)"
			[inputElement]="projectInput"
			[onlyAssignedReadOnly]="onlyAssignedReadOnly"
			[multiSelect]="true"
			[onlyValidBUs]="true"
			[calledFromAggregatedProject]="true"
		></app-project-autocomplete>
	</mat-form-field>

	@for (project of selectedProjects; track project) {
		<div class="mep-list-entry mep-text-big no-pp">
			<div>
				{{ project.projectName }}
			</div>
			<div class="entry_close">
				<mat-icon (click)="onProjectSelectionRemove(project)">close</mat-icon>
			</div>
		</div>
	}
</div>

<div class="mep-dialog-actions">
	<button (click)="closeDialog()" class="mep-btn-dialog-secondary">
		{{ _lang("close") }}
	</button>
	<button
		(click)="addProject()"
		[disabled]="selectedProjects && selectedProjects.length === 0"
		class="mep-btn-dialog-primary"
	>
		{{ _lang("add-project") }}
	</button>
</div>
